import request from '@/utils/request'
import { arrayToFormDataToSave } from '@/utils/file.js'

// 조회
export function getEmergencyGuideMap(param, isNotify) {
  return request({
    url: '/api/getEmergencyGuideMap',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 디테일 조회
export function getEmergencyGuideMapDetail(param, isNotify) {
  return request({
    url: '/api/getEmergencyGuideMapDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 가이드맵 적용 여부 확인
export function checkApplyGuideMap(param) {
  return request({
    url: '/api/checkApplyGuideMap',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' }
  })
}
// 저장
export function saveEmergencyGuideMap(param, isNotify) {
  const formData = arrayToFormDataToSave(param)
  return request({
    url: '/api/saveEmergencyGuideMap',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: formData,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

//삭제
export function deleteEmergencyGuideMap(param, isNotify) {
  return request({
    url: '/api/deleteEmergencyGuideMap',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}